import { combineReducers } from 'redux';

import emailVerification from '../routes/EmailVerification/reducers/email-verification';
import forgot_password from '../routes/ForgotPassword/reducers/forgot-password';
import login from '../routes/Login/reducers/login';
import loginAuthorisation from '../routes/LoginAuthorisation/reducers/login-authorisation';
import country from './country';
import language from './language';
import registrationCountries from './registration-countries';

const myApp = combineReducers({
  country,
  emailVerification,
  forgot_password,
  language,
  login,
  loginAuthorisation,
  registrationCountries,
});

export default myApp;
